export default {"src":"/_next/static/media/3.01e86beb.svg","height":170,"width":305,"blurWidth":0,"blurHeight":0};